// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  jobs: {
    list: path(ROOTS_DASHBOARD, '/jobs/list')
  },
  reports: {
    list: path(ROOTS_DASHBOARD, '/reports/list')
  },
  cameras: {
    list: path(ROOTS_DASHBOARD, '/cameras/list')
  },
  contacts: {
    root: path(ROOTS_DASHBOARD, '/contacts'),
    list: path(ROOTS_DASHBOARD, '/contacts/list'),
    newContact: path(ROOTS_DASHBOARD, '/contacts/new'),
    editContact: path(ROOTS_DASHBOARD, '/contacts/edit')
  },
  vehicles: {
    root: path(ROOTS_DASHBOARD, '/vehicles'),
    list: path(ROOTS_DASHBOARD, '/vehicles/list'),
    newVehicle: path(ROOTS_DASHBOARD, '/vehicles/new'),
    editVehicle: path(ROOTS_DASHBOARD, '/vehicles/edit')
  },
  drivers: {
    root: path(ROOTS_DASHBOARD, '/drivers'),
    list: path(ROOTS_DASHBOARD, '/drivers/list'),
    newDriver: path(ROOTS_DASHBOARD, '/drivers/new'),
    editDriver: path(ROOTS_DASHBOARD, '/drivers/edit')
  },
  contactSite: {
    root: path(ROOTS_DASHBOARD, '/sites'),
    list: path(ROOTS_DASHBOARD, '/sites/list'),
    newContactSite: path(ROOTS_DASHBOARD, '/sites/new')
  },
  companies: {
    root: path(ROOTS_DASHBOARD, '/companies'),
    list: path(ROOTS_DASHBOARD, '/companies/list'),
    newCompany: path(ROOTS_DASHBOARD, '/companies/new'),
    editCompany: path(ROOTS_DASHBOARD, '/companies/edit')
  },
  transactions: {
    list: path(ROOTS_DASHBOARD, '/transactions/list'),
    editTransaction: path(ROOTS_DASHBOARD, '/transactions/edit'),
    newTransaction: path(ROOTS_DASHBOARD, '/transactions/new')
  },
  products: {
    list: path(ROOTS_DASHBOARD, '/products/list'),
    newProduct: path(ROOTS_DASHBOARD, '/products/new'),
    editProduct: path(ROOTS_DASHBOARD, '/products/edit')
  },
  settings: {
    list: path(ROOTS_DASHBOARD, '/settings/list')
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/jobs/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  }
};
